<template>
  <header id="header">
    <div id="content">
      <span>
        <template v-if="!shop_isLogin">
          <el-link @click="toPage('/PC/login?isLogin=true')" :underline="false">
            您好，请登录
          </el-link>
          <el-link style="margin-left: 10px;color: #0eb054;" @click="toPage('/PC/login?isLogin=false')" type="primary"
            :underline="false">
            免费注册
          </el-link>
        </template>
        <template v-else style="font-size: 12px">
          <el-link :underline="false">
            <span @click="toIndex()" style="color: #939393;">
              <!-- <i class="el-icon-s-home m-r-5" style="font-size: 20px;"></i> -->
              首页</span>
            <span class="m-l-20 m-r-20" style="color: #939393;">{{ this.shop_userInfo.nickname }}</span>
          </el-link>
          <el-link style="color: #0eb054;" @click="logout" type="primary" :underline="false">
            退出登录
          </el-link>
        </template>
      </span>
      <span class="rightLink">
        <!-- <el-link style="color: #939393;" :underline="false">
          快捷采购
        </el-link> -->
        <!-- <span style="color: #939393;" class="div"> | </span> -->
        <el-link @click="caitui()" style="color: #939393;" :underline="false">
          慧采云课堂
        </el-link>
        <span style="color: #939393;" class="div"> | </span>
        <el-link @click="mobile()" style="color: #939393;" :underline="false">
          慧采移动端
        </el-link>
        <span style="color: #939393;" class="div"> | </span>
        <el-link @click="mine()" style="color: #939393;" :underline="false">
          个人中心
        </el-link>
        <span style="color: #939393;" class="div"> | </span>
        <el-link @click="shop()" style="color: #939393;" :underline="false">
          商家中心
        </el-link>
        <span style="color: #939393;" class="div"> | </span>
        <el-link @click="feedback()" style="color: #939393;" :underline="false">
          意见反馈
        </el-link>
        <span style="color: #939393;" class="div"> | </span>
        <!-- <el-link style="color: #939393;" :underline="false">
          帮助中心
        </el-link> -->
        <!-- <span style="color: #939393;" class="div"> | </span> -->
        <el-link @click="callPhone" style="font-weight: bold;color: #000;" :underline="false">
          <i style="font-size: 18px;" class="el-icon-phone"></i>
          15910900011
        </el-link>
      </span>
    </div>
  </header>
</template>

<script>
import Cookies from 'js-cookie';
export default {
  name: 'HeaderPart',
  data() {
    return {
      shop_isLogin: localStorage.getItem('shop_isLogin'),
      shop_userInfo: JSON.parse(localStorage.getItem('shop_userInfo')),
    }
  },
  methods: {
    feedback() {
      this.$router.push('/PC/feedback');
    },
    //明医云慧采课堂
    caitui() {
      window.open('http://new_website.caitui.cn/#/?website_id=43')
    },
    //个人中心
    mine() {
      window.open('https://company.caitui.cn/login')
    },
    //商家中心
    shop() {
      window.open('https://shop.caitui.cn/web/index.php?m=admin/passport/login')
    },
    //移动端
    mobile() {
      var url = "https://shop.caitui.cn/webpage/#/auth/login"
      //创建一个input元素
      let input = document.createElement('input')
      //给input的内容复制
      input.value = url
      // 在body里面插入这个元素
      document.body.appendChild(input)
      // 选中input里面内容
      input.select()
      //执行document里面的复制方法
      document.execCommand("Copy")
      // 复制之后移除这个元素
      document.body.removeChild(input)
      this.$message({
        message: '复制成功！',
        type: 'success'
      });
    },
    callPhone() {
      window.location.href = 'tel:15910900011';
    },
    toIndex() {
      this.$router.push('/PC/index');
    },
    toPage(item) {
      this.$router.push(item);
    },
    logout() {
      localStorage.removeItem('shop_isLogin')
      localStorage.removeItem('shop_access_token')
      localStorage.removeItem('shop_userInfo')
      Cookies.remove('isLogin')
      this.$router.push({ path: '/PC/login', query: { isLogin: true } })
    },
  },
};
</script>

<style scoped>
#header span {
  color: rgb(80, 82, 89);
}

#header {
  width: 100%;
  height: 40px;
  line-height: 40px;
  background-color: #ffffff;
  padding: 0 0;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.06);
  font-size: 12px;
}

#content {
  width: 1350px;
  margin: 0 auto;
  position: relative;
  top: 0;
  left: 0;
  right: 0;
}

.rightLink {
  position: absolute;
  right: 0;
}

.div {
  margin-left: 5px;
  margin-right: 5px;
}
</style>


// WEBPACK FOOTER //
// src/views/PC/header/HeaderPart.vue